function About() {
  return (
    <div>
      {/* ── Hero ────────────────────────────────────────────────────── */}
      <section style={{ padding: '80px 0 64px' }}>
        <div className="fc-wrap">
          <span className="fc-eyebrow">Om os</span>
          <h1 style={{
            fontSize: 'clamp(36px, 6vw, 64px)',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            lineHeight: 1.05,
            color: 'var(--text-primary)',
            marginBottom: 20,
            maxWidth: 700,
          }}>
            Et regnskab<br />
            der <em style={{ fontStyle: 'normal', color: 'var(--primary-color)' }}>holder</em>.
          </h1>
          <p style={{
            fontSize: 18,
            lineHeight: 1.7,
            color: 'var(--text-secondary)',
            maxWidth: 560,
          }}>
            Faircast er en dansk podcast-platform bygget på ét princip: 80% af det du betaler går direkte til de skabere du lytter til. Det er ikke marketing — det er regnskab.
          </p>
        </div>
      </section>

      {/* ── Mission ─────────────────────────────────────────────────── */}
      <section style={{ padding: '64px 0', background: 'var(--bg-card)', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)' }}>
        <div className="fc-wrap">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}>
            <div>
              <span className="fc-eyebrow">Missionen</span>
              <h2 className="fc-section-title">Fordi skabere fortjener en fair deal</h2>
              <p className="fc-section-sub">
                De fleste streaming-platforme tager 30–50% og fordeler resten efter mystiske algoritmer. Vi tager 20% — præcis nok til drift — og resten fordeles proportionalt efter din faktiske lyttetid.
              </p>
              <p style={{ marginTop: 16, fontSize: 16, color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                Hvis du bruger halvdelen af din tid på ét podcast, får det halvdelen af dine 24 kr. Ingen skjulte gebyrer, ingen algoritme der favoriserer de store.
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {[
                { num: '80%', label: 'Går til skaberne', sub: 'Altid. Ingen undtagelser.' },
                { num: '20%', label: 'Til Faircast', sub: 'Drift, infrastruktur, support.' },
                { num: '30 kr', label: 'Pr. måned', sub: 'Alt indhold. Ingen binding.' },
              ].map(item => (
                <div key={item.num} style={{
                  background: 'var(--bg-elevated)',
                  border: '1px solid var(--border-color)',
                  borderRadius: 16,
                  padding: '20px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                }}>
                  <div style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: 28,
                    fontWeight: 800,
                    color: 'var(--primary-color)',
                    minWidth: 72,
                  }}>{item.num}</div>
                  <div>
                    <div style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: 2 }}>{item.label}</div>
                    <div style={{ fontSize: 13, color: 'var(--text-mute)' }}>{item.sub}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Principles ──────────────────────────────────────────────── */}
      <section style={{ padding: '64px 0' }}>
        <div className="fc-wrap">
          <span className="fc-eyebrow">Principper</span>
          <h2 className="fc-section-title" style={{ marginBottom: 48 }}>Det vi tror på</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {[
              { icon: '🎙️', title: 'Skaberne kommer først', body: 'En platform er kun så god som det indhold der er på den. Vi designer alle vores beslutninger med skabernes interesser for øje.' },
              { icon: '📖', title: 'Gennemsigtighed er standard', body: 'Du kan altid se præcis hvad dine penge gør. Vi publicerer vores forretningsmodel åbent og ændrer den aldrig uden varsel.' },
              { icon: '🇩🇰', title: 'Dansk podcast fortjener et hjem', body: 'Vi er bygget til dansk indhold på et dansk marked. Sprog, valuta og lovgivning er ikke eftertanker — de er udgangspunktet.' },
              { icon: '🚫', title: 'Ingen annoncer. Nogensinde.', body: 'Vores eneste forretningsmodel er abonnementet. Vi sælger ikke din opmærksomhed eller dine data til tredjeparter.' },
              { icon: '⚖️', title: 'Fair fordeling', body: 'Proportional fordeling efter lyttetid er det eneste retfærdige system. Ikke algoritmer, ikke "editorial picks", ikke betalt placering.' },
              { icon: '🔒', title: 'GDPR ved design', body: 'Vi indsamler kun de data vi faktisk behøver. Du ejer dine data og kan til enhver tid bede om at få dem slettet.' },
            ].map(item => (
              <div key={item.title} style={{
                background: 'var(--bg-card)',
                border: '1px solid var(--border-color)',
                borderRadius: 20,
                padding: '32px 28px',
              }}>
                <div style={{
                  width: 44, height: 44,
                  background: 'var(--primary-dim)',
                  borderRadius: 12,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 20,
                  marginBottom: 16,
                }}>{item.icon}</div>
                <h3 style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8, fontSize: 16 }}>{item.title}</h3>
                <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.65 }}>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ─────────────────────────────────────────────────────── */}
      <section style={{ padding: '64px 0', background: 'var(--bg-card)', borderTop: '1px solid var(--border-color)' }}>
        <div className="fc-wrap" style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(24px, 4vw, 40px)', fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--text-primary)', marginBottom: 16 }}>
            Klar til at prøve?
          </h2>
          <p style={{ fontSize: 17, color: 'var(--text-secondary)', marginBottom: 32, lineHeight: 1.6 }}>
            30 kr om måneden. Opsig hvornår du vil.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/subscribe" className="fc-cta-primary">Kom i gang for 30 kr/md</a>
            <a href="/for-creators" className="fc-cta-ghost">Jeg er skaber →</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
